import { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { DropDownMenu } from "@etframework/ui.components";
import { useTaskTypeByBoardId } from "../../data/queries/taskTypeQueries";

export const TaskTypeDropDown = forwardRef(
  ({ change, id, currentBoardId, initialValue }, ref) => {
    const [boardId, setBoardId] = useState(currentBoardId);
    const { data: taskTypes } = useTaskTypeByBoardId(boardId);
    const [taskTypeId, setTaskTypeId] = useState(
      initialValue ?? taskTypes?.[0]?.Id
    );

    const getRuleDropdownOptions = () =>
      taskTypes?.map((taskType) => {
        return {
          id: taskType.Id,
          text: taskType.Title,
          iconCss: taskType.Id == taskTypeId ? "fa-solid fa-check" : "",
          onClick: () => {
            setTaskTypeId(taskType.Id);
            change?.(taskType);
          },
        };
      });

    const handleRuleSelectMenuItem = (args) => {
      args?.onClick?.();
    };

    useImperativeHandle(ref, () => ({
      getValue: () => taskTypes?.find((x) => x.Id === taskTypeId),
      setBoardId,
    }));

    useEffect(() => {
      setTaskTypeId(initialValue ?? taskTypes?.[0]?.Id);
    }, [taskTypes]);

    return (
      <div className="d-flex jsutify-content-start align-items-center gap-1">
        <i className="fa-regular fa-list-check"></i>
        <DropDownMenu
          id={id}
          select={handleRuleSelectMenuItem}
          items={getRuleDropdownOptions()}
        >
          <div className="task-type-dd-title">
            {taskTypes?.find((x) => x.Id === taskTypeId)?.Title}
          </div>
        </DropDownMenu>
      </div>
    );
  }
);
